import React from 'react'


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const InputDate = ({ title="", value="", type="date", handleChange, enabled=false }) => {
  return (
    <div className={'flex flex-col'}>
        <label className={'text-white'}>{title}</label>
        <input
          type={type}
          disabled={enabled}
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          className={classNames(!enabled ? 'bg-white' : 'bg-gray-400', 'rounded-md p-2')}
        ></input>
    </div>
  )
}

export default InputDate